import React from 'react';
import { Card } from './ui/card';
import { Target, Lightbulb, Network } from 'lucide-react';

export const Mission = () => {
  const values = [
    {
      icon: Target,
      title: "Breaking Boundaries",
      description: "We challenge the traditional path. Business skills aren't confined to consulting firms and banks—they're essential across every industry."
    },
    {
      icon: Network,
      title: "Cross-Faculty Connections",
      description: "We bring together students from engineering, science, law, and business. Innovation happens at the intersection of disciplines."
    },
    {
      icon: Lightbulb,
      title: "Expanding Horizons",
      description: "We introduce you to opportunities you didn't know existed. From aerospace to pharmaceuticals, your degree opens unexpected doors."
    }
  ];

  return (
    <section id="mission" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#FAF8F6]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Our Mission
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Telfer Gateway Society exists because <span className="font-semibold text-[#8B1538]">business skills are universal</span>. 
            We connect Telfer students with industries beyond traditional business sectors, 
            opening doors to engineering firms, tech companies, law practices, and research institutions.
          </p>
        </div>

        {/* The Problem */}
        <div className="mb-16">
          <Card className="p-8 sm:p-12 bg-white border-2 border-slate-200 shadow-lg">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6 text-center">
                The Problem We're Solving
              </h3>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                Most Telfer clubs are <span className="font-semibold">industry-focused</span>—pushing students toward consulting, 
                accounting, and finance. While these are great paths, they make it harder for students to realize they can work 
                at an engineering firm, a biotech startup, a government research lab, or a law practice.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                <span className="font-semibold text-[#8B1538]">Every industry needs business minds.</span> Project managers at engineering firms. 
                Operations specialists in pharmaceutical companies. Financial analysts at tech startups. 
                Telfer Gateway Society is here to make those connections visible and accessible.
              </p>
            </div>
          </Card>
        </div>

        {/* Core Values */}
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <Card
                key={index}
                className="p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-slate-100 hover:border-[#8B1538]/20 bg-white"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full bg-[#8B1538]/10 flex items-center justify-center mb-6">
                    <Icon className="h-8 w-8 text-[#8B1538]" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">{value.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{value.description}</p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
